import styled from "styled-components";
import { breakpoints } from "../../../../constants/media";

const Container = styled.div`
  width: 100%;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  // Header Bar Open and Close
  .headerBarOpen,
  .headerBarClose {
    width: 100%;
    border: 0px;
    max-width: calc(1300px - 30px);
    margin: 0 auto;
    border-radius: 12px 12px 12px 12px !important;
    display: flex;
    flex-wrap: wrap;
    min-height: 56px;
    justify-content: space-between;
    align-items: center;
    align-content: center;
    padding: 17px 15px 17px 15px;
    pointer-events: none;
    background-color: var(--white);
  }

  // Logo and Plan Seguro
  .logoPlan {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: row;
    max-width: 111px;
    min-width: 111px;
    border-right: 1px solid var(--lightgray2);
    padding: 0px 18px 0px 0px;
  }

  .logoPlan img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }

  .logoPlan p {
    font-family: Raleway;
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    text-align: center;
    color: var(--orange);
    margin: 7px 0px 0px 0px;
  }

  // Checks Plan
  .checksPlan {
    display: flex;
    justify-content: space-between;
    margin: 0px 25px 0px 0px;
    align-content: center;
    align-items: center;
  }

  .checksPlan span {
    width: 135px;
    text-align: center;
    color: var(--green);
    font-size: 1.1em;
  }

  #checkNo {
    color: red !important;
    font-size: 1em;
  }

  .checkPlan section {
    min-width: 135px;
  }

  // Informacion de precios Container
  .priceData {
    max-width: 135px;
    min-width: 135px;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    flex-wrap: wrap;
    flex-direction: row;
  }

  // Informacion de precios
  .priceData div {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  // Informacion de precios text
  .priceData div p {
    margin: 0px 3px 0px 3px;
    font-family: Raleway;
    font-style: normal;
  }

  // Cuotas y precio anterior
  .priceData div:nth-child(1) {
    font-weight: normal;
    font-size: 13px;
    text-align: center;
    color: var(--lightgray);

    #precioAnterior {
      text-decoration: line-through;
      font-weight: bold;
    }

    .cuotasNaranja {
      color: var(--orange) !important;
    }

    #cuotasBold {
      font-weight: 600 !important;
    }
  }

  // Precio y oferta
  .priceData div:nth-child(2) {
    font-weight: 600;
    font-size: 15px;
    text-align: center;
    color: var(--orange);
    margin: 6px 0px 6px 0px;
  }

  // Contratando
  .priceData div:nth-child(3) {
    font-weight: 600;
    font-size: 11px;
    text-align: center;
    color: var(--orange);
  }

  // Arrow Container
  .arrowContainer {
    display: none;
    justify-content: center;
    align-items: center;
    align-content: center;
    position: relative;
  }

  // Arrow
  .arrowContainer i {
    position: absolute;
    right: 0;
    top: calc(50% - 8px);
    width: 8px;
    height: 8px;
    display: block;
    border-left: 3px solid var(--orange);
    border-bottom: 3px solid var(--orange);
    transform: rotate(-45deg);
    z-index: 99;
    border-radius: 10%;
  }

  // Buttons Container
  .buttonsContainer {
    max-width: 125px;
    min-width: 125px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: row;
  }

  #contrataButton {
    width: 100%;
    background-color: var(--orange);
    padding: 10px 0px 10px 0px;
    border: 0;
    color: var(--white);
    cursor: pointer;
    font-family: Raleway;
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
    text-align: center;
    border-radius: 6px;
    transition: 0.1s all;
    pointer-events: all;
  }

  #verMasButton {
    border: 0px;
    cursor: pointer;
    margin: 12px 0px 0px 0px;
    background-color: transparent;
    font-family: Raleway;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    text-align: center;
    color: var(--orange);
    pointer-events: all;
  }

  #contrataButton:hover,
  .panelContainer button:hover {
    background-color: var(--lightorange);
  }

  #verMasButton:hover {
    color: var(--black);
  }

  // Text Container
  .childrenContainer {
    width: 100%;
    margin: 0px 0px 0px 0px;
    padding: 0px 0px 0px 0px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
    align-content: center;
  }

  // Tiempo de transicion cuando se abre y se cierra
  .ReactCollapse--collapse {
    transition: height 600ms;
  }

  // 1366px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1366}) {
    // Logo Plan
    .logoPlan p {
      font-size: 12px;
    }

    // Checks Plan
    .checksPlan span {
      width: 110px;
      font-size: 1.2em;
    }
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    // Logo and Plan Seguro
    .logoPlan {
      max-width: 90px;
      min-width: 90px;
    }

    // Checks Plan
    .checksPlan span {
      width: 92.5px;
      font-size: 1.1em;
    }

    // Buttons Container
    .buttonsContainer {
      max-width: 100px;
      min-width: 100px;
    }

    #contrataButton {
      font-size: 12px;
    }

    #verMasButton {
      font-size: 11px;
    }

    .dataPanelContainer {
      width: 90%;
    }

    .detallesContainer,
    .beneficiosContainer {
      width: 45%;
    }
  }

  // 1024px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet1024}) {
    // Logo and Plan Seguro
    .logoPlan {
      max-width: 110px;
      min-width: 110px;
    }

    // Checks Plan
    .checksPlan {
      margin: 0px 0px 0px 0px !important;
    }

    .checksPlan span {
      display: none;
    }

    // Informacion de precios Container
    .priceData {
      padding: 0px 18px 0px 18px;
    }

    // Buttons Container
    .buttonsContainer {
      padding: 0px 0px 0px 18px;
      border-left: 1px solid var(--lightgray2);
    }

    #verMasButton {
      font-size: 12px;
    }

    .dataPanelContainer {
      width: 90%;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: center;
    }

    .detallesContainer,
    .beneficiosContainer {
      width: 80%;
      margin: 30px 0px 0px 0px;
    }

    .panelPlanSeguro {
      width: 90%;
      flex-wrap: wrap;
      flex-direction: row;
    }

    .panelPlanSeguro p {
      width: 100%;
      margin: 16px 0px 0px 0px !important;
    }

    .panelPlanSeguro p:nth-child(2) {
      display: none;
    }

    .panelVigenciaButton {
      width: 90%;
    }
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    // Header Bar Open and Close
    .headerBarOpen,
    .headerBarClose {
      pointer-events: initial;
      cursor: pointer;
      justify-content: center;
    }

    // Button
    .button {
      flex-wrap: wrap;
      flex-direction: row;
      pointer-events: all;
      justify-content: center;
    }

    // Logo and Plan Seguro
    .logoPlan {
      border-right: 0px;
      padding: 0px 15px 0px 0px;
    }

    // Informacion de precios Container
    .priceData {
      padding: 0px 0px 0px 15px;
    }

    // Arrow Container
    .arrowContainer {
      display: flex;
      padding: 0px 0px 0px 34px;
    }

    // Buttons Container
    .buttonsContainer {
      max-width: none;
      min-width: none;
      width: 35%;
      padding: 0px 0px 0px 0px;
      margin: 20px 0px 0px 0px;
      border-left: 0px;
    }

    #verMasButton {
      display: none;
    }
  }

  // 414px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile414}) {
    // Logo and Plan Seguro
    .logoPlan {
      padding: 0px 5px 0px 0px;
    }

    // Informacion de precios Container
    .priceData {
      padding: 0px 0px 0px 5px;
    }

    // Arrow Container
    .arrowContainer {
      display: flex;
      padding: 0px 0px 0px 24px;
    }
  }

  // 375px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile375}) {
    // Logo and Plan Seguro
    .logoPlan {
      padding: 0px 2px 0px 0px;
    }

    // Informacion de precios Container
    .priceData {
      padding: 0px 0px 0px 2px;
    }

    // Arrow Container
    .arrowContainer {
      display: flex;
      padding: 0px 0px 0px 15px;
    }
  }

  // 350px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile350}) {
    // Logo and Plan Seguro
    .logoPlan {
      width: 100%;
      padding: 0px 0px 25px 0px;
    }

    // Informacion de precios Container
    .priceData {
      width: 90%;
      padding: 0px 25px 0px 0px;
    }

    // Arrow Container
    .arrowContainer {
      width: 10%;
      padding: 0px 0px 0px 0px;
    }
  }
`;

export default Container;
